import React from 'react'

import { ChatbotContainer } from 'features/profile/pages/Chatbot/components/ChatbotContainer'

export const Chatbot = () => <ChatbotContainer />
